<template>
  <div :class="['wrapper', { 'wrapper__paddingless': !!this.mode }]">
    <CustomCheckbox
      v-if="this.showCheckbox() && this.floorsPlan?.length"
      :value="allSelected"
      @change="selectAll"
      :small="true"
      style="margin-bottom: 15px;"
      label="Выбрать все"
    />
    <div
      v-if="this.floorsPlan?.length"
      v-for="floor in this.floorsPlan"
      :key="floor.floor_map_id"
      class="floor"
    >
      <CustomCheckbox
        v-if="this.showCheckbox(floor)"
        :value="floor?.is_selected"
        @change="(value) => onCheckboxChange(floor, value)"
        :small="true"
      />
      <div
        v-else-if="this.mode === 'flat-grouping' || this.mode === 'floor-grouping'"
        style="width: 30px;"
      ></div>
      <span class="floorNum">{{ floor.floor }}</span>
      <div class="apartments">
        <div
          v-for="apartment in floor.flat"
          :key="apartment.flat_id"
          :class="['apartment', { apartment__small: !!this.mode, apartment__cursorPointer: !this.mode }]"
          @click="() => this.onApartmentClick && this.onApartmentClick({...apartment, floor: floor.floor, floor_map_id: floor.floor_map_id, colour_id: floor.colour_id }, )"
          :style="`background-color: ${this.getCellColor(floor, apartment)}`"
        >
          <q-tooltip anchor="center middle">
            <p v-if="apartment.remont_id" style="margin: 0; font-size: 13px;">
              remont_id = {{ apartment.remont_id }}
            </p>
            <p v-if="apartment.flat_id" style="margin: 0; font-size: 13px;">
              flat_id = {{ apartment.flat_id }}
            </p>
          </q-tooltip>
          <span class="apartmentRoomCnt">
            {{ apartment.room_cnt }}
          </span>
          <span class="apartmentInfo">{{ apartment.area }} м²</span>
          <span class="apartmentInfo">кв. {{ apartment.flat_num }}</span>
          <span
            v-if="!!apartment.remont_id"
            class="apartmentInfo"
            style="font-size: 11px;"
          >
            #{{ apartment.remont_id }}</span
          >
        </div>
      </div>
      <div v-if="!!this.getFloorData && !this.mode" style="font-weight: 500;">
        <q-tooltip> Контрольная сумма </q-tooltip>
        {{ this.getFloorData(floor.floor) }}
      </div>
      <div
        v-if="floor?.smeta_status_code && !this.mode"
        style="font-weight: 500;"
      >
        <div
          :class="`text-subtitle2 ${floor?.smeta_status_code === 'SUCCESS' ? 'text-green-7' : 'text-deep-orange-14'}`"
          style="width: fit-content; line-height: 17px; white-space: nowrap;"
        >
          {{floor?.smeta_status_code === 'SUCCESS' ? 'Успешно рассчитана смета' : 'Ошибка'}}
          <q-icon v-if="!!floor.smeta_error" name="info" />
          <q-tooltip v-if="floor.smeta_error" class="bg-red text-caption">
            {{ floor.smeta_error }}
          </q-tooltip>
        </div>
        <div class="text-caption" style="line-height: 15px;">
          Последний пересчет:
          {{ floor.smeta_recalc_date }}
        </div>
      </div>
      <div
        v-if="this.smetaLoading && this.smetaLoading[floor.floor_map_id]"
        style="width: 20px;"
      >
        <CustomLoader small v-if="this.smetaLoading[floor.floor_map_id]" />
      </div>
      <CustomSelect
        v-if="this.mode === 'grouping' && !!floor.floor_map_id"
        :options="this.colors"
        label="Группа"
        style="width: 100px;"
        optionValueKey="colour_id"
        optionLabelKey="label"
        :value="floor.colour_id"
        @change="value => this.onGroupChange(value, floor.floor_map_id, floor.floor)"
        :clearable="false"
        :colorMode="true"
      />
    </div>
    <NotFoundText
      v-else-if="!this.isFetching"
      :text="this.show ? 'Нет данных' : 'Заполните данные'"
    />
  </div>
</template>

<script>
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomSelect from "@/components/form/CustomSelect";
import NotFoundText from "@/components/common/NotFoundText.vue";
import { changeFloorGroup, getEntranceColors, checkFlatFloor } from "./services";
import { hexToRgba } from "@/services";
import CustomLoader from "@/components/common/CustomLoader";

export default {
  name: 'ResidentialApartmentsList',
  components: {CustomCheckbox, CustomSelect, NotFoundText, CustomLoader},
  props: ['onApartmentClick', 'floorsPlan', 'floorSmetaData', 'mode', 'updateData', 'checkboxMode', 'params', 'addData', 'getFloorData', 'isFetching', 'show', 'smetaLoading'],
  data() {
    return {
      loading: {},
      creatingRemont: {},
      colors: [],
    };
  },
  computed: {
    allSelected() {
      return this.floorsPlan?.every(item => item.is_selected)
    },
  },
  methods: {
    hexToRgba,
    async onGroupChange(colour_id, floor_map_id, floor) {
      if(this.loading[floor]) return
      const body = {
        is_new_group: colour_id === 'new_group',
        floor_map_id,
        colour_id: colour_id === 'new_group' ? null : colour_id
      }
      this.loading[floor] = true
      const res = await changeFloorGroup(body, this.params)
      this.loading[floor] = false
      if(!res) return
      this.updateData && this.updateData(res)
      this.getColors()
    },
    async getColors() {
      if(this.mode !== 'grouping') return
      const res = await getEntranceColors(this.params)
      if(!res) return
      this.colors = res
    },
    async selectAll(value) {
      const updatedData = this.floorsPlan.map(floor => ({ ...floor, is_selected: value }));
      this.updateData && this.updateData(updatedData)
    },
    showCheckbox(floor) {
      if(this.checkboxMode) return true
      if(this.mode !== 'flat-grouping' && this.mode !== 'floor-grouping') return false
      if(!floor) return false
      const {floor_map_id, colour_id} = floor

      if(this.mode === 'flat-grouping') {
        if(!floor_map_id || colour_id !== this.addData?.colour_id)
          return false
      }
      if(this.mode === 'floor-grouping') {
        if(!floor_map_id) return true
        if(colour_id !== this.addData?.colour_id) return false
      }
      return true
    },
    onCheckboxChange(floor, value) {
      const {floor_map_id, floor: key} = floor
      if(this.params?.floor_map_id === floor_map_id) return
      const updatedData = this.floorsPlan.map(floor => {
        if (floor.floor === key) {
          return { ...floor, is_selected: value };
        }
        return floor;
      });
      this.updateData && this.updateData(updatedData)
    },
    getCellColor(floor, apartment) {
      if(this.mode !== 'flat-grouping') return hexToRgba(floor.hex_code, .5)
      return checkFlatFloor(floor, apartment, this.addData) ? 'rgba(173 ,102 ,255, .5)' : hexToRgba(floor.hex_code, .5)
    }
  },
  mounted() {
    this.getColors()
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 20px;

  &__paddingless {
    padding: 0;
  }
}
.floor {
  margin-bottom: 5px; display: flex; gap: 15px; align-items: center;
}
.floorNum {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.apartments {
  display: flex; gap: 5px; align-items: center;
}
.apartment {
  width: 90px;
  height: 90px; padding: 5px;
  border-radius: 12px;
  background-color: #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: .3s all;

  &:hover {
    background-color: #d2dce3;
  }

  &__cursorPointer {
    cursor: pointer;
  }

  &__small {
    width: 70px;
    height: 70px;
  }
}
.apartmentRoomCnt {
  font-size: 16px;
  font-weight: bold;
  color: #474747;
}
.apartmentInfo {
  font-size: 12px;
  color: #474747;
}
</style>
